import { NoProductFound } from "@ten24/slatwall-storefront-react-private/global";
import ContentLoader from "react-content-loader";
import { ProductCardWithDetail } from "../ProductCard/ProductCardWithDetail/ProductCardWithDetail";

const ListingGridLoader = (props) => (
  <ContentLoader viewBox="0 0 500 250">
    <rect x="0" y="0" rx="4" ry="4" width="500" height="80" />
    <rect x="0" y="85" rx="4" ry="4" width="500" height="80" />
    <rect x="0" y="170" rx="4" ry="4" width="500" height="80" />
  </ContentLoader>
);

const ListingListView = ({ cardDisplayConfigurations, isFetching, pageRecords, config }) => {
  let cardConfig = cardDisplayConfigurations.skuCardConfiguration;
  if (config?.params?.productsListingFlag) {
    cardConfig = cardDisplayConfigurations.productCardConfiguration;
  }

  return (
    <>
      {isFetching && (
        <>
          <ListingGridLoader />
        </>
      )}
      <div className="product-list">
        {!isFetching &&
          pageRecords?.map((product, index) => {
            return <ProductCardWithDetail key={index} cardConfiguration={cardConfig} product={product} />;
          })}
      </div>
      {!isFetching && pageRecords.length === 0 && <NoProductFound noProductFoundLink={config.noProductFoundLink} />}
    </>
  );
};
export { ListingListView };
